import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonApiController from "services/common.service";
// import { setMessage } from "./message";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const commonErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const SampleClientExportApi = createAsyncThunk("common/SampleClientExport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await commonApiController
      .sampleClientExport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "SampleClientExport"))
      .catch((error) => HandleError(thunkAPI, error, "SampleClientExport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SampleProductExportApi = createAsyncThunk("common/SampleProductExport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await commonApiController
      .sampleProductExport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "SampleProductExport"))
      .catch((error) => HandleError(thunkAPI, error, "SampleProductExport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const TimezoneApi = createAsyncThunk("common/timezone", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await commonApiController
      .timezone(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "timezone"))
      .catch((error) => HandleError(thunkAPI, error, "timezone"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const WhenToSendApi = createAsyncThunk("common/whentosend", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await commonApiController
      .whentosend(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "whentosend"))
      .catch((error) => HandleError(thunkAPI, error, "whentosend"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const checkUserApi = createAsyncThunk("consultationform/checkuser", async (formValues, thunkAPI) => {
  try {
    const resposedata = await commonApiController
      .checkuser(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "checkuser"))
      .catch((error) => HandleError(thunkAPI, error, "checkuser"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isTimezone: "",
  isTimezoneError: "",
  isSampleClientExport: "",
  isSampleClientExportError: "",
  isSampleProductExport: "",
  isSampleProductExportError: "",
  isWhenToSend: "",
  isWhenToSendError: "",
  isCheckUser: "",
  isCheckUserError: "",
  isValidatationAlertPopups: "",
  isopenAppointmentConfirmationAlerts: "",
  isAppointmentConfirmationStatus: "",
  isOpenImportErrorLog: "",
  isImportErrorLogTableData: "",
  isComingSoonPopUpAlerts: "",
  isComingSoonPopUpAlertsTextsData: "",
  isOpenCustomAlerts: "",
  customAlertErrors: null,
  customAlertResponse: null,
  isApiStatus: {
    TimezoneApi: "",
    SampleClientExportApi: "",
    SampleProductExportApi: "",
    WhenToSendApi: "",
  },
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenValidationAlerts: (state, action) => {
      state.isValidatationAlertPopups = action.payload;
    },
    OpenAppointmentConfirmationAlerts: (state, action) => {
      state.isopenAppointmentConfirmationAlerts = action.payload;
    },
    AppointmentConfirmationStatus: (state, action) => {
      state.isAppointmentConfirmationStatus = action.payload;
    },
    OpenImportErrorLog: (state, action) => {
      state.isOpenImportErrorLog = action.payload;
    },
    ImportErrorLogTableData: (state, action) => {
      state.isImportErrorLogTableData = action.payload;
    },
    ComingSoonPopUpAlerts: (state, action) => {
      state.isComingSoonPopUpAlerts = action.payload;
    },
    ComingSoonPopUpAlertsTextsData: (state, action) => {
      state.isComingSoonPopUpAlertsTextsData = action.payload;
    },
    OpenCustomAlerts: (state, action) => {
      state.isOpenCustomAlerts = action.payload.isOpen;
      state.customAlertErrors = action.payload.errors;
      state.customAlertResponse = action.payload.response;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(TimezoneApi.pending, (state) => {
        state.isTimezoneError = "";
        state.isApiStatus = { ...state.isApiStatus, TimezoneApi: "loading" };
      })
      .addCase(TimezoneApi.fulfilled, (state, action) => {
        state.isTimezone = action.payload;
        state.isTimezoneError = "";
        state.isApiStatus = { ...state.isApiStatus, TimezoneApi: "succeeded" };
      })
      .addCase(TimezoneApi.rejected, (state, action) => {
        state.isTimezoneError = commonErrorMessage(action, "Unable to load time zones.");
        state.isApiStatus = { ...state.isApiStatus, TimezoneApi: "failed" };
      })
      .addCase(SampleClientExportApi.pending, (state) => {
        state.isSampleClientExportError = "";
        state.isApiStatus = { ...state.isApiStatus, SampleClientExportApi: "loading" };
      })
      .addCase(SampleClientExportApi.fulfilled, (state, action) => {
        state.isSampleClientExport = action.payload;
        state.isSampleClientExportError = "";
        state.isApiStatus = { ...state.isApiStatus, SampleClientExportApi: "succeeded" };
      })
      .addCase(SampleClientExportApi.rejected, (state, action) => {
        state.isSampleClientExportError = commonErrorMessage(action, "Unable to export clients.");
        state.isApiStatus = { ...state.isApiStatus, SampleClientExportApi: "failed" };
      })
      .addCase(SampleProductExportApi.pending, (state) => {
        state.isSampleProductExportError = "";
        state.isApiStatus = { ...state.isApiStatus, SampleProductExportApi: "loading" };
      })
      .addCase(SampleProductExportApi.fulfilled, (state, action) => {
        state.isSampleProductExport = action.payload;
        state.isSampleProductExportError = "";
        state.isApiStatus = { ...state.isApiStatus, SampleProductExportApi: "succeeded" };
      })
      .addCase(SampleProductExportApi.rejected, (state, action) => {
        state.isSampleProductExportError = commonErrorMessage(action, "Unable to export products.");
        state.isApiStatus = { ...state.isApiStatus, SampleProductExportApi: "failed" };
      })
      .addCase(WhenToSendApi.pending, (state) => {
        state.isWhenToSendError = "";
        state.isApiStatus = { ...state.isApiStatus, WhenToSendApi: "loading" };
      })
      .addCase(WhenToSendApi.fulfilled, (state, action) => {
        state.isWhenToSend = action.payload;
        state.isWhenToSendError = "";
        state.isApiStatus = { ...state.isApiStatus, WhenToSendApi: "succeeded" };
      })
      .addCase(WhenToSendApi.rejected, (state, action) => {
        state.isWhenToSendError = commonErrorMessage(action, "Unable to load send-time options.");
        state.isApiStatus = { ...state.isApiStatus, WhenToSendApi: "failed" };
      })
      .addCase(checkUserApi.pending, (state) => {
        state.isCheckUserError = "";
        state.isApiStatus = { ...state.isApiStatus, checkUserApi: "loading" };
      })
      .addCase(checkUserApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, checkUserApi: "succeeded" };
        state.isCheckUser = action.payload;
        state.isCheckUserError = "";
      })
      .addCase(checkUserApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, checkUserApi: "failed" };
        state.isCheckUserError = commonErrorMessage(action, "Unable to check user.");
      });
  },
});

export const { reset, OpenValidationAlerts, OpenAppointmentConfirmationAlerts, AppointmentConfirmationStatus, OpenImportErrorLog, ImportErrorLogTableData, ComingSoonPopUpAlerts, ComingSoonPopUpAlertsTextsData, OpenCustomAlerts } = commonSlice.actions;
export default commonSlice.reducer;
